export default function MySQL_LOCALTIME() {
  return (
    <div>
      <h2>MySQL_LOCALTIME</h2>    </div>
  );
}